import { IndexModel } from "../Support/IndexModel";
export class CampaignIndex extends IndexModel {
    endpoint = 'campaign';
    getData() {
        return super.getData();
    }
}
